// @flow

import getCurrentPlanIndex from '../getCurrentPlanIndex';
import getPlanComparativeInfo from '../getPlanComparativeInfo';
import groupPlansByType from '../groupPlansByType';
import intervalizePlans from '../intervalizePlans';
import recommendPlan from '../recommendPlan';
import removeUnusedLegacyPlans from '../removeUnusedLegacyPlans';
import sortPlansForDisplay from '../sortPlansForDisplay';
import toPlan from '../toPlan';

import type { AccountPlan, Interval, Plan } from '@zapier/common-utils';

/**
 * Takes in raw AccountPlans from the API and formats them so that the frontend
 * can consume them this includes:
 *
 * 1. Intervalizing plans (if required)
 * 2. Filtering out legacy plans (if not current plan)
 * 3. Mapping prop names to the ones used by frontend
 * 4. Sorting plans in display order
 * 5. Adding features / comparison info to each plan
 * 6. Marking recommend plan (if applicable)
 */
export default (
  currentPlanId: number,
  accountPlans: Array<AccountPlan>,
  shouldIntervalize: boolean = false,
  selectedInterval?: Interval,
  isFall2019Pricing?: boolean = false
): Array<Plan> => {
  if (!accountPlans || !Array.isArray(accountPlans) || !accountPlans.length)
    return [];

  const intervalized = shouldIntervalize
    ? intervalizePlans(accountPlans)
    : accountPlans;

  const filteredPlans = removeUnusedLegacyPlans(intervalized, currentPlanId);

  const plansByType = isFall2019Pricing
    ? groupPlansByType(filteredPlans, currentPlanId, selectedInterval)
    : filteredPlans;

  const plans = plansByType.map(plan => toPlan(plan, selectedInterval));
  const sortedPlans = sortPlansForDisplay(plans);
  const plansWithFeatures = getPlanComparativeInfo(
    currentPlanId,
    sortedPlans,
    isFall2019Pricing
  );

  const currentPlanIndex = getCurrentPlanIndex(
    plansWithFeatures,
    currentPlanId
  );

  const plansWithRecommendation = recommendPlan(
    plansWithFeatures,
    currentPlanIndex
  );

  return plansWithRecommendation;
};
